import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('homebattery');
    return (
        <div id="B" className={`home-battery-B home-battery-box ${css['home-battery-B']}`}>
            <h2 className="title">{t('secB_title')}</h2>
            <div className="img-box">
                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718950030800/img01.jpg" alt={t('secB_title')} />
            </div>
            <p className="desc">{t('secB_desc')}</p>
            <Link
                className="link"
                href="https://blog.ecoflow.com/jp/recommendation/"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'select_news',
                    title_name: t('secB_title'),
                    button_name: t('secB_link'),
                }}
            >
                {t('secB_link')}
            </Link>
        </div>
    );
}
